import { render, staticRenderFns } from "./AHAppBanner.vue?vue&type=template&id=a670fc5e&"
import script from "./AHAppBanner.vue?vue&type=script&lang=ts&"
export * from "./AHAppBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports